export type FontAwesomeType = 'fa' | 'far' | 'fas' | 'fal' | 'fab' | 'fa-kit'

export function isFontAwesomeType(type: string): type is FontAwesomeType {
  return ['fa', 'far', 'fas', 'fal', 'fab', 'fa-kit'].includes(type)
}
